<template>
   
    <div>
        <div class="common-part hide" >
            <a href="javascript:;" class="allmenu-btn">menu</a>
            <div class="main-part" v-show="menu">
                <div class="top-part">
                    <div class="name">
                        {{this.datatext[0].webtitle}}
                    </div>
                    <div class="second-title">
                        <div class="small">{{this.datatext[0].bigarea}}</div>
                        <div class="main">{{this.datatext[0].mainarea}}</div>
                    </div>

                    <div class="banner">
                        <img src="images/icons/banner.jpg">
                    </div>
                    <div class="language-box">
                        <div class="box">
                            <a :href="this.LinklangTw(this.$route.path)">繁</a>
                            <a :href="this.LinklangEn(this.$route.path)">En</a>
                            <a :href="this.LinklangJa(this.$route.path)">日</a>
                        </div>

                    </div>
                </div>
                <div class="bottom-part" id="bar-control-box">
                    <nav id="menu" aria-label="Main menu" >
                        <ul>
                            <!--00 東勢全景-->
                            <li>      
                                <router-link to="/location00"   class="firsr-menu-btn menu-btn">
                                    <div class="menu-img-box">
                                        <div class="menu-img">
                                            <img :src="PicturePath(this.data00[0].mainimg)">
                                        </div>
                                        <span>{{this.data00[0].name}}</span>
                                    </div>
                                </router-link>
                            </li>

                            <!--01 美濃湖-->
                            <li>      
                                <router-link to="/location01"  class="firsr-menu-btn menu-btn">
                                    <div class="menu-img-box">
                                        <div class="menu-img">
                                            <img :src="PicturePath(this.data01[0].mainimg)">
                                        </div>
                                        <span>{{this.data01[0].name}}</span>
                                    </div>
                                </router-link>
                                <ul class="submenu">
                                    <li>
                                        <router-link to="/location0111" class="menu-btn">
                                            <span>{{this.data01[1].name}}</span>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/location0121" class="menu-btn">
                                            <span>{{this.data01[3].name}}</span>
                                        </router-link>
                                    </li>                              
                                </ul>
                            </li>

                            <!--02 美濃客家文物館-->
                            <li>
                                <router-link to="/location02"  class="firsr-menu-btn menu-btn">
                                    <div class="menu-img-box">
                                        <div class="menu-img">
                                            <img :src="PicturePath(this.data02[0].mainimg)">
                                        </div>
                                        <span>{{this.data02[0].area}}</span>
                                    </div>
                                </router-link>
                                <ul class="submenu">
                                    <li>
                                        <router-link to="/location0211" class="menu-btn">
                                            <span>{{this.data02[1].name}}</span>
                                        </router-link>
                                    </li>    
                                    <li>
                                        <router-link to="/location0221" class="menu-btn">
                                            <span>{{this.data02[2].name}}</span>
                                        </router-link>
                                    </li>   
                                    <li>
                                        <router-link to="/location0231" class="menu-btn">
                                            <span>{{this.data02[4].name}}</span>
                                        </router-link>
                                    </li>  
                                </ul>
                            </li>

                            <!--03 鍾理和紀念館-->
                            <li>
                                <router-link to="/location03"  class="firsr-menu-btn menu-btn">
                                    
                                    <div class="menu-img-box">
                                        <div class="menu-img">
                                            <img :src="PicturePath(this.data03[0].mainimg)">
                                        </div>
                                        <span>{{this.data03[0].area}}</span>
                                    </div>
                                </router-link>
                                <ul class="submenu">
                                    <li>
                                        <router-link to="/location0311" class="menu-btn">
                                            <span>{{this.data03[1].name}}</span>
                                        </router-link>
                                    </li>  
                                    <li>
                                        <router-link to="/location0321" class="menu-btn">
                                            <span>{{this.data03[2].name}}</span>
                                        </router-link>
                                    </li>  
                                                                        <li>
                                        <router-link to="/location0331" class="menu-btn">
                                            <span>{{this.data03[3].name}}</span>
                                        </router-link>
                                    </li>    
                                </ul>
                            </li>

                            <!--04 永安老街-->
                            <li>
                                <router-link to="/location04"  class="firsr-menu-btn menu-btn">
                                    
                                    <div class="menu-img-box">
                                        <div class="menu-img">
                                            <img :src="PicturePath(this.data04[0].mainimg)">
                                        </div>
                                        <span>{{this.data04[0].area}}</span>
                                    </div>
                                </router-link>
                                <ul class="submenu">
                                    <li>
                                        <router-link to="/location0411" class="menu-btn">
                                            <span>{{this.data04[1].name}}</span>
                                        </router-link>
                                    </li>    
                                    <li>
                                        <router-link to="/location0421" class="menu-btn">
                                            <span>{{this.data04[2].name}}</span>
                                        </router-link>
                                    </li>           
                                    <li>
                                        <router-link to="/location0430" class="menu-btn">
                                            <span>{{this.data04[4].name}}</span>
                                        </router-link>
                                    </li>   
                                    <li>
                                        <router-link to="/location0441" class="menu-btn">
                                            <span>{{this.data04[12].name}}</span>
                                        </router-link>
                                    </li> 
                                    <li>
                                        <router-link to="/location0451" class="menu-btn">
                                            <span>{{this.data04[13].name}}</span>
                                        </router-link>
                                    </li>  
                                    <li>
                                        <router-link to="/location0461" class="menu-btn">
                                            <span>{{this.data04[15].name}}</span>
                                        </router-link>
                                    </li>       
                                    <li>
                                        <router-link to="/location0471" class="menu-btn">
                                            <span>{{this.data04[17].name}}</span>
                                        </router-link>
                                    </li>     
                                    <li>
                                        <router-link to="/location0481" class="menu-btn">
                                            <span>{{this.data04[18].name}}</span>
                                        </router-link>
                                    </li>                                                                                                                                                                                                              
                                </ul>
                            </li>

                            <!--05 廣善堂-->
                            <li>
                                <router-link to="/location05"  class="firsr-menu-btn menu-btn">
                                    <div class="menu-img-box">
                                        <div class="menu-img">
                                            <img :src="PicturePath(this.data05[0].mainimg)">
                                        </div>
                                        <span>{{this.data05[0].area}}</span>
                                    </div>
                                </router-link>
                                <ul class="submenu">
                                    <li>
                                        <router-link to="/location0511" class="menu-btn">
                                            <span>{{this.data05[1].name}}</span>
                                        </router-link>
                                    </li>             
                                    <li>
                                        <router-link to="/location0521" class="menu-btn">
                                            <span>{{this.data05[2].name}}</span>
                                        </router-link>
                                    </li>   
                                    <li>
                                        <router-link to="/location0523" class="menu-btn">
                                            <span>{{this.data05[4].name}}</span>
                                        </router-link>
                                    </li> 
                                    <li>
                                        <router-link to="/location0531" class="menu-btn">
                                            <span>{{this.data05[5].name}}</span>
                                        </router-link>
                                    </li>                                
                                </ul>
                            </li>

                            <!--06 伯公尋訪趣-->
                            <li>
                                <router-link to="/location06"  class="firsr-menu-btn menu-btn">
                                    <div class="menu-img-box">
                                        <div class="menu-img">
                                            <img :src="PicturePath(this.data06[0].mainimg)">
                                        </div>
                                        <span>{{this.data06[0].area}}</span>
                                    </div>
                                </router-link>
                                <ul class="submenu">
                                    <li>
                                        <router-link to="/location0611" class="menu-btn">
                                            <span>{{this.data06[1].name}}</span>
                                        </router-link>
                                    </li>   
                                    <li>
                                        <router-link to="/location0621" class="menu-btn">
                                            <span>{{this.data06[2].name}}</span>
                                        </router-link>
                                    </li>  
                                    <li>
                                        <router-link to="/location0631" class="menu-btn">
                                            <span>{{this.data06[4].name}}</span>
                                        </router-link>
                                    </li>     
                                    <li>
                                        <router-link to="/location0121" class="menu-btn">
                                            <span>{{this.data01[3].name}}</span>
                                        </router-link>
                                    </li>        
                                    <li>
                                        <router-link to="/location0461" class="menu-btn">
                                            <span>{{this.data04[15].name}}</span>
                                        </router-link>
                                    </li>                              
                                </ul>
                            </li>

                            <!--07 美濃民俗村-->
                            <li>
                                <router-link to="/location07"  class="firsr-menu-btn menu-btn">
                                    <div class="menu-img-box">
                                        <div class="menu-img">
                                            <img :src="PicturePath(this.data07[0].mainimg)">
                                        </div>
                                        <span>{{this.data07[0].area}}</span>
                                    </div>
                                </router-link>
                                <ul class="submenu">
                                    <li>
                                        <router-link to="/location0711" class="menu-btn">
                                            <span>{{this.data07[1].name}}</span>
                                        </router-link>
                                    </li>    
                                    <li>
                                        <router-link to="/location0721" class="menu-btn">
                                            <span>{{this.data07[2].name}}</span>
                                        </router-link>
                                    </li>    
                                    <li>
                                        <router-link to="/location0722" class="menu-btn">
                                            <span>{{this.data07[3].name}}</span>
                                        </router-link>
                                    </li>    
                                </ul>
                            </li>

                        </ul>
                    </nav>
                </div>
                <a href="javascript:;" class="phoneclose-btn">closemenu</a>
            </div>
            
        </div>
        
        <!--位置資訊-->
        <div class="Directions-menu hideDirections" >
            <div class="top-half" >
                <div class="spot-img">
                    <img :src="PicturePath(this.$store.state.locationRenew.mainimg)">
                </div>
                <div class="spot-sounds">
                    <div class="sounds-btns">
                        <a href="javascript:;" class="sounds-box1-btn">{{this.datatext[0].soundtext}}</a> 
                        <a href="javascript:;" class="sounds-box2-btn">客語介紹</a>
                    </div>
                    <div class="all-sounds-box">
                        <div class="sounds-box1">
                            <audio id="audio1" controls :src="Sounds(this.$store.state.locationRenew.sound1)" controlsList="nodownload noplaybackrate"></audio>
                        </div> 
                        <div class="sounds-box2">
                            <audio id="audio2" controls :src="Sounds(this.$store.state.locationRenew.sound2)" controlsList="nodownload noplaybackrate"></audio>
                        </div> 
                    </div>                    
                </div>
                <div class="spot-inf">
                    <div class="spot-name">{{this.$store.state.locationRenew.name}}</div>
                    <p>{{this.$store.state.locationRenew.inf}}</p>
                </div>
            </div>

            <a href="javascript:;"  class="closeDirections">關閉資訊</a>
        </div>


        <!--03位置地圖-->
       
        <div class="MapMenubox" v-show="MapMenubox">
            <div class="main-box">
                <iframe :src="IframeMap(this.$store.state.locationRenew.iframemap)" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
            <a href="javascript:;"  class="closeMapMenubox">關閉資訊</a>
        </div>
        
        <!--04影片-->
        <div class="VideoMenubox" v-show="VideoMenubox">
            <div class="main-box">
                 <iframe width="560" height="315" :src="IframeVideo(this.$store.state.locationRenew.youtube)" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <a href="javascript:;"  class="closeVideoMenubox">關閉資訊</a>
        </div>    

        <!--01看更多客庄-->
        <div class="moreLinkBox" v-show="moreLinkBox">    
            <div class="moreLink-main">
                <a href="javascript:;" class="moreLinkBox-close">關閉</a>
                <div class="link-box">
                    <div class="title">{{this.datatext[0].moreLinktitle}}</div>
                    <div class="link-box-main">     
                        <a :href="this.datatext[0].moreLink1">
                            <div class="link-img">
                                <img src="images/region/01.png">
                            </div>
                            <div class="link-title">
                                {{this.datatext[0].moreLink1title}}
                            </div>
                        </a>
                        <a :href="this.datatext[0].moreLink2">
                            <div class="link-img">
                                <img src="images/region/02.png">
                            </div>
                            <div class="link-title">
                                {{this.datatext[0].moreLink2title}}
                            </div>
                        </a>   
                        <a :href="this.datatext[0].moreLink3">
                            <div class="link-img">
                                <img src="images/region/03.png">
                            </div>
                            <div class="link-title">
                                {{this.datatext[0].moreLink3title}}
                            </div>
                        </a>  
                        <a :href="this.datatext[0].moreLink4">
                            <div class="link-img">
                                <img src="images/region/04.png">
                            </div>
                            <div class="link-title">
                                {{this.datatext[0].moreLink4title}}
                            </div>
                        </a>  
                        <a :href="this.datatext[0].moreLink5">
                            <div class="link-img">
                                <img src="images/region/05.png">
                            </div>
                            <div class="link-title">
                                {{this.datatext[0].moreLink5title}}
                            </div>
                        </a>  
                        <a :href="this.datatext[0].moreLink6">
                            <div class="link-img">
                                <img src="images/region/06.png">
                            </div>
                            <div class="link-title">
                                {{this.datatext[0].moreLink6title}}
                            </div>
                        </a>  
                        <a :href="this.datatext[0].moreLink7">
                            <div class="link-img">
                                <img src="images/region/07.png">
                            </div>
                            <div class="link-title">
                                {{this.datatext[0].moreLink7title}}
                            </div>
                        </a>  
                        <a :href="this.datatext[0].moreLink8">
                            <div class="link-img">
                                <img src="images/region/08.png">
                            </div>
                            <div class="link-title">
                                {{this.datatext[0].moreLink8title}}
                            </div>
                        </a> 
                        <a :href="this.datatext[0].moreLink9">
                            <div class="link-img">
                                <img src="images/region/09.png">
                            </div>
                            <div class="link-title">
                                {{this.datatext[0].moreLink9title}}
                            </div>
                        </a>    
                        <a :href="this.datatext[0].moreLink10">
                            <div class="link-img">
                                <img src="images/region/10.png">
                            </div>
                            <div class="link-title">
                                {{this.datatext[0].moreLink10title}}
                            </div>
                        </a>          
                        <a :href="this.datatext[0].moreLink11">
                        <div class="link-img">
                            <img src="images/region/11.png">
                        </div>
                        <div class="link-title">
                            {{this.datatext[0].moreLink11title}}
                        </div>
                        </a>     
                        <a :href="this.datatext[0].moreLink12">
                        <div class="link-img">
                            <img src="images/region/12.png">
                        </div>
                        <div class="link-title">
                            {{this.datatext[0].moreLink12title}}
                        </div>
                        </a>     
                        <a :href="this.datatext[0].moreLink13">
                        <div class="link-img">
                            <img src="images/region/13.png">
                        </div>
                        <div class="link-title">
                            {{this.datatext[0].moreLink13title}}
                        </div>
                        </a>                                                                      
                    </div>
                </div>
            </div>
        </div>

        <!--04操作說明-->
        <div class="qaBox" v-show="qaBox">    
            <div class="qaBox-main">
                <a href="javascript:;" class="qaBox-close">關閉</a>
                <div class="qaBox-main-img">
                    <img :src="PicturePath(this.datatext[0].qaimg)">
                </div>
            </div>
        </div>


        <!--最下面按鈕-->
        <div class="bottom-btns ">
            <div class="box">
                <a href="javascript:;" id="moreLink">看更多客庄</a>
                <a href="javascript:;" id="modeButton">VR模式</a>
                <a href="javascript:;" id="mapButton">地圖盒</a>
                <a href="javascript:;" id="fullscreenButton">全螢幕</a>
                <a href="javascript:;" id="qaBtn">操作說明</a>
            </div>

        </div>


            
    </div>



                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
</template>




<script>

import $ from 'jquery';
import * as PANOLENS from 'panolens'


    export default {
        data() {
            return {
                moreLinkBox:false,
                qaBox:false,
                menu:false,
                MapMenubox:false,
                VideoMenubox:false,
            };
        },
         watch: {

         },
        methods: {

            // 圖片
            PicturePath(id) {
                if( id === null  )
                {
                    return `./default.png`; 
                }
                else 
                {
                    return `./images/${id}`;
                }
            },


        },
        mounted: function () {
     
                
            this.$nextTick(function () {
                             
 
                /* */
                $('#moreLink').bind('click',function () {
                    this.moreLinkBox = true
                    $('.moreLinkBox').fadeIn(300);
                })

                $('.moreLinkBox-close').on('click', function (e) {
                    $('.moreLinkBox').fadeOut(300);
                });


                /*全螢幕 */
                $('#fullscreenButton').bind('click',function () {
                    if (document.fullscreenElement) {
                        document.exitFullscreen();
                    }
                    document.body.requestFullscreen();
                })

               //vr盒
                var modeButton = document.querySelector( '#modeButton' );
                modeButton.addEventListener( 'click', function(){
                    $('.peoplemap-part .viewer').fadeToggle(300);
                    $('.common-part').fadeToggle(300);
                } );

                //操作說明
                $('#qaBtn').on('click', function (e) {
                    this.qaBox = true
                    $('.qaBox').fadeToggle(300);
                });
                
                $('.qaBox-close').on('click', function (e) {
                    $('.qaBox').fadeOut(300);
                });

                

                const self = this;
                $('.allmenu-btn').on('click', function (e) {
                    
                    $('.common-part').removeClass("open");
                    if($('.common-part').hasClass("hide"))
                    {       
                        $('.common-part').removeClass("hide");
                        $('.common-part').addClass("open");
                        self.menu = true
                    }
                    else
                    {
                        $('.common-part').addClass('hide');
                    }
                });

                $('.phoneclose-btn').on('click', function (e) {
                    $('.common-part').removeClass("open");
                    $('.common-part').addClass('hide');
                });




                $('.closeDirections').on('click', function (e) { 
                    $('.Directions-menu').removeClass("openDirections");
                    $('.Directions-menu').addClass('hideDirections');
                    allAudios.forEach(function(audio){
                        audio.pause();
                    });
                });




                $('.submenu .menu-btn').on('click', function (e) {
                    $('.submenu .menu-btn').removeClass("current");
                    $(this).toggleClass("current");
                });

                $('#menu a').on('click', function (e) {
                    if (window.innerWidth <= 530) {
                        $('.common-part').removeClass("open").addClass('hide');
                    }
                });

                /*位置地圖盒子 */
                $('#mapButton').on('click', function (e) {
                    this.MapMenubox = true
                    $('.MapMenubox').fadeToggle(300);
                });
                
                /*影片盒子 */
                $('.video-btn').on('click', function (e) {
                    this.VideoMenubox = true
                });
                

                $('.closeMapMenubox').on('click', function (e) {
                    $('.MapMenubox').fadeOut(300);
                });

                $('.closeVideoMenubox').on('click', function (e) {
                    $('.VideoMenubox').fadeOut(300);
                    var iframes = document.querySelectorAll('iframe');
                    // reinitializing the values of the src attribute of every iframe to stop the YouTube video.
                    for (let i = 0; i < iframes.length; i++) {
                        if (iframes[i] !== null) {
                        var temp = iframes[i].src;
                        iframes[i].src = temp;
                        }
                    }
                });


                var allAudios = document.querySelectorAll('audio');
                

                $('.sounds-box1-btn').on('click', function (e) {
                    $('.all-sounds-box').fadeIn(300);
                    $('.sounds-box2').fadeOut(300);
                    $('.sounds-box1').fadeIn(300);
                    $('.sounds-box2-btn').removeClass("current");
                    $('.sounds-box1-btn').addClass("current");
                    allAudios.forEach(function(audio){
                        audio.pause();
                    });
                });
                $('.sounds-box2-btn').on('click', function (e) {
                    $('.all-sounds-box').fadeIn(300);
                    $('.sounds-box1').fadeOut(300);
                    $('.sounds-box2').fadeIn(300);
                    $('.sounds-box2-btn').addClass("current");
                    $('.sounds-box1-btn').removeClass("current");
                    allAudios.forEach(function(audio){
                        audio.pause();
                    });
                });

            })
        },

    }
</script>